<template>

  <div class="tg-wrapper" v-on:click="postponeIdleTimer()">

    <div class="home-overlay" v-show="showHome" v-on:click="hideHome()">
      <div class="home-overlay--large">
        <h2>BÂTIMENTS ET TRACES INDUSTRIELLES AU VAL-DE-TRAVERS</h2>
        <p>Pour le Musée régional du Val-de-Travers, la constitution d’une collection de  photos de bâtiments industriels répond à deux buts</p>
        <ul>
          <li>Conserver un arrêt sur images de ce patrimoine, dans son état actuel, c’est à dire les années 2015-2020</li>
          <li>Mettre en évidence les caractéristiques architecturales, souvent modestes mais aussi parfois de grande qualité, de ce type de bâtiments, de cas  en cas menacés d’altérations ou de disparition.</li>
        </ul>
        <h3>APPEL :</h3>
        <p>Si vous possédez des informations complémentaires concernant ces bâtiments ou d’autres, n’hésitez pas à nous en faire part par courriel à info@mrvt.ch</p>
        <p>Photographies : Lucas Vuitel, Laurence Vaucher<br/>
        Réalisation : Laurence Vaucher et Benoit Conrath (glossaire horloger)</p>
      </div>
      <div class="home-overlay--small">
        <h3>Sources :</h3>
        <ul>
          <li>Indicateur Davoine et Indicateur général pour l’horlogerie, années 1935, 1940, 1045, 1950, 1955, 1960, 1980</li>
          <li>JÉQUIER François, Une entreprise horlogère au Val-de-Travers, Fleurier Watch, 1977</li>
          <li>PIGUET Claire, INSA Inventaire Suisse d’architecture, Neuchâtel, volume7, tiré à part « Val-de-Travers », 2000</li>
          <li>PIGUET Claire, Le Val-de-Travers une région une identité, 2008</li>
          <li>RUB Gaston et CHAPUIS Alfred, Le Val-de-Travers industriel, L’horlogerie au Val-de-Travers de ses origines à nos jours, 1937</li>
          <li>SORGESA MIÉVILLE Béatrice, De la société traditionnelle à l’ère industrielle, Fleurier 1727-1914, 1992</li>
        </ul>
        <h3>En ligne :</h3>
        <p>Cadastre neuchâtelois des sites pollués https://www.ne.ch/autorites/DDTE/SENE/sites-pollues</p>
        <h3>Nous adressons nos sincères remerciements à :</h3>
        <p>Mmes Simone Bach, Catherine Bortolini, Marie Bourgnon, Delphine Doumas, Anne-Marie Niederhauser ainsi qu’à MM. Maël Jeannin, Jean-Pierre Jelmini, Michel Niederhauser, Olivier Pianaro</p>
      </div>
    </div>  

    <div id="particles-js" class="confetti-overlay"></div>  

    <gallery-detail ref="galleryDetail"></gallery-detail>

    <div class="timeline-gallery">

      <scroll-sync proportional horizontal class="tg-gallery" ref="gallery">

        <div class="tg-gallery__pane" v-for="(imagesSrc, key) in imagesSrcLists" :key="imagesSrc.key" :data-key="imagesSrc.key" ref="galleryItem">
          <span class="meta-year">{{ Math.abs(imagesSrc.key) }}</span>
          <div class="image-frame" v-for="image in imagesSrc.value" 
                v-bind:key="image.id" 
                v-on:click="showDetail(image.id)"
                v-bind:class="{ 'is--with-archive': image.src_past }">

            <div class="image-frame-header">
              <h2 class="image-frame-header__title">{{ image.address_street }}</h2>
              <div class="image-frame-header__subtitle">{{ image.location }}</div>  
            </div>    

            <img v-bind:src="image.src" @load="imageLoaded">
            <svg>
              <mask :id="'m-' + image.id" fill='#fff'>
                <rect :id="'b-' + image.id" width='100%' height='100%'/>
                <circle :id="'c-' + image.id" r='16' fill='#000'/>
                <use :xlink:href="'#c-' + image.id" x='100%'/>
                <use :xlink:href="'#c-' + image.id" y='100%'/>
                <use :xlink:href="'#c-' + image.id" x='100%' y='100%'/>
              </mask>
              <use :xlink:href="'#b-' + image.id" :mask="'url(#m-' + image.id + ')'"/>
            </svg>
          </div>

        </div>
      </scroll-sync>

      <div class="tg-timeline">
        <div class="tg-timeline__sep"></div>
        <scroll-sync proportional horizontal class="tg-timeline__scroller" ref="timeline">
          <span class="meta-year" v-for="(imagesSrc, key) in imagesSrcLists" :key="imagesSrc.key" v-on:click="scrollToYear(imagesSrc.key)" v-bind:style="{ marginLeft: ((imagesSrc.value.length - 0.25) * 50) + 'px' }" ref="menuItem">
            {{imagesSrc.title}}
          </span>
          <div class="scroll-offset">&nbsp;</div>
        </scroll-sync>
      </div>

    </div>

  </div>

</template>

<script>

import axios from 'axios';
import _ from 'lodash';
import Vue from 'vue';
import GalleryDetail from '../components/GalleryDetail.vue';
import 'particles.js';

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

import ScrollSync from 'vue-scroll-sync';
Vue.use(ScrollSync);

let INDUS_VOC = ["Aiguilles","Anneaux, couronnes et pendants pour boîtes de montres","Articles de ménage chromés","Atelier","Balancier","Boîte","Boîte de montre métal","Cadran","Chronographe","Chronomètre de poche et de marine","Classe d'horlogerie","Composants","Comptoir","Consortium","Couronne","Dorage","Ebauche","Echappement","Entreprise horlogère","Etablissage  – Etablir –","Etablisseur","Fabrication hydraulique d'électricité","Fabrication mécanique de la montre","Fabrique","Finissage","Fonderie","Forge","Fraise","Galvanoplastie","Haute horlogerie","Horlogerie ","Laine de bois","Laminoir à métaux pour l'horlogerie","Machine-outil","Manufacture ","Mécanique","Montre","Montre argent","Montres chinoises","Mouvement","Mouvement horloger de haute précision","Ouvrières et ouvriers ","Pierres fines pour l'horlogerie","Polissage","Production d'outils horlogers","Ressorts-fils","Ressort","Roue hydraulique pour la fabrication de l'électricité","Scierie","Scies","Sous-traitance","Spiraux ","Terminage ","Tours à pivoter","Verre de montre","Vis de balanciers"];

export default {
  name: 'TimelineGallery',
  props: {
    msg: String
  },
  components: {
    'scroll-sync': ScrollSync,
    'gallery-detail': GalleryDetail
  },
  data: function () {

    return {
      apiUrl: 'https://api.airtable.com/v0/appkWAjnJQYt0eshb/',
      apiToken: 'pat5nUMvxRSgAkb56.e8d1dbe6b098d6ba313c444bfaa9ec368dcde48542c19925b98f220f5e7abed5', // Màj 2026 -> pat
      base: 'borne_traces_industrielles',
      imagesSrcLists: null,
      imagesSrcListsRaw: [],
      panePositions: [],
      rotateLoader : 0,
      hasScrolled: null,
      showHome: true,
      lastScrollX: 0,
      speed: 0,
      idleTime: null
    };

  },

  mounted: function () {
    this.getData();
  },

  methods: {

    getData: function (offset) {

      var self = this;

      var request = {
        url: this.apiUrl + this.base,
        headers: {
          'Authorization': `Bearer ${this.apiToken}`
        }
      };

      if (offset) {
        request.params = {
          'offset': offset
        }
      }

      axios(request).then((res) => {
        
        var records = res.data.records;

        console.log('records', records);

        var count = 0;
        records.forEach(function(item) {

          if (item.fields.year_filter) {

            var yearRangeStart = null;
            if (_.inRange(item.fields.year_filter, 1850, 1870)) {
              yearRangeStart = 1850;
            } else if (_.inRange(item.fields.year_filter, 1871, 1890)) {
              yearRangeStart = 1871;
            } else if (_.inRange(item.fields.year_filter, 1891, 1914)) {
              yearRangeStart = 1891;
            } else if (_.inRange(item.fields.year_filter, 1915, 1949)) {
              yearRangeStart = 1915;
            } else if (_.inRange(item.fields.year_filter, 1950, 1990)) {
              yearRangeStart = 1950;
            } else {
              yearRangeStart = 1991;
            }

            var prettyCaption = item.fields.caption;
            if (item.fields.caption) {
              prettyCaption = '<p>' + item.fields.caption.split(' / ').join('</p><p>') + '</p>';

              _.each(INDUS_VOC, function(voc) {
                prettyCaption = prettyCaption.split(' ' + voc + ' ').join(' <mark>' + voc + '</mark>');
                prettyCaption = prettyCaption.split('(' + voc + ')').join(' <mark>' + voc + '</mark>');

                let normalizedVoc = voc.toLowerCase();
                prettyCaption = prettyCaption.split(' ' + normalizedVoc + ' ').join(' <mark>' + normalizedVoc + '</mark> ');
                prettyCaption = prettyCaption.split('(' + normalizedVoc + ')').join('(<mark>' + normalizedVoc + '</mark>)');
              });
            }

            var pastImages = null;
            if (item.fields.ref_image_past) {
              pastImages = _.map(item.fields.ref_image_past.split('\n'), function(image) {
                return 'img/photo/' + image;
              });
            }

            self.imagesSrcListsRaw.push({
              id : item.id,
              src : 'img/photo/' + item.fields.ref_image_present,
              src_past : pastImages,
              caption : prettyCaption,
              year : yearRangeStart,
              year_full : item.fields.year_filter,
              year_built : item.fields.year_built,
              location : item.fields.address_location,
              address_street : item.fields.address_street,
              building_owner : item.fields.building_owner,
              building_purpose_past : item.fields.building_purpose_past,
              building_type : item.fields.building_type,
              building_purpose_present : item.fields.building_purpose_present
            });  
          }

          count++;
        }); 

        var offset = res.data.offset;

        if (offset) {

          self.getData(offset);

        } else {

          this.imagesSrcListsRaw = _.sortBy(this.imagesSrcListsRaw, function (x) {
            return parseInt(x.year);
          });

          var grouped = _.groupBy(this.imagesSrcListsRaw, function (x) {
            return parseInt(x.year);
          });

          this.imagesSrcLists = [];
          for (var key in grouped) {

              var value = _.sortBy(grouped[key], function (x) {
                return parseInt(x.year_full);
              }).reverse();
              var yearRangeTitle = '';
              if (key == 1850) {
                yearRangeTitle = "1870 • 1850";
              } else if (key == 1871) {
                yearRangeTitle = "1890 • 1871";
              } else if (key == 1891) {
                yearRangeTitle = "1914 • 1891";
              } else if (key == 1915) {
                yearRangeTitle = "1949 • 1915";
              } else if (key == 1950) {
                yearRangeTitle = "1990 • 1950";
              } else {
                yearRangeTitle = "2020 • 1991";
              }

              this.imagesSrcLists.push({
                key: key,
                value: value,
                title: yearRangeTitle
              })
          }

          window.imagesSrcLists = this.imagesSrcLists;

          this.imagesSrcLists = this.imagesSrcLists.reverse();

          this.init();

        }

      });
    },

    init: function () {

      var self = this;

      this.$nextTick(this.computePanePosition);
      this.$nextTick(this.handleScroll);
      
      window.setTimeout(function() {
        self.$refs.timeline.$el.scrollLeft = self.$refs.timeline.$el.scrollWidth;
      }, 500);

      document.querySelector('.tg-gallery').addEventListener('scroll', self.handleScroll);
      document.querySelector('.tg-gallery').addEventListener('scroll', self.setSpeed);
      document.querySelector('.tg-gallery').addEventListener('scroll', self.setLoaderRotation);

      // TODO : clean
      /*setTimeout(function() {
        document.querySelector('body').classList.add('is--loaded');
      }, 1000);*/
    },

    postponeIdleTimer: function () {
      
      var self = this;

      window.clearTimeout(this.idleTimer);
      this.idleTimer = _.delay(function() {

        if (!self.showHome) {
          self.showHome = true;
          self.$refs.timeline.$el.scrollLeft = self.$refs.timeline.$el.scrollWidth;
          self.$refs.galleryDetail.close();
        }

      }, 180000);
    },

    hideHome: function () {
      this.showHome = false;
    },
    computePanePosition: function () {

      var self = this;
      this.panePositions = [];

      _.each(this.$refs.galleryItem, function (pane, i) {
        self.panePositions.push( pane.getBoundingClientRect().left + ((i == 0)? 200 : 0) );
      });

      this.$refs.gallery.$el.classList.add('is--3d');

    },

    handleScroll: _.throttle ( function () {

      var self = this;
      var scrollX = this.$refs.gallery.$el.scrollLeft;
      var active = 0;
    
      var activePane = 0;
      if (scrollX > 0) {

        this.panePositions.forEach(function (panePos, i) {
          
          if (scrollX + (0.2 * 1920) > panePos) {
            activePane = i;
          }

        });
      }

      this.panePositions.forEach(function (panePos, i) {
        
        if (i == activePane) {
          self.$refs.menuItem[i].classList.add('is--active');
          self.$refs.galleryItem[i].classList.add('is--active');
        } else {
          self.$refs.menuItem[i].classList.remove('is--active');
          self.$refs.galleryItem[i].classList.remove('is--active');
        }

      });

    }, 200),

    setLoaderRotation: function () {

      var self = this;
      var scrollX = this.$refs.gallery.$el.scrollLeft;

      this.rotateLoader = scrollX / 200 % Math.PI;
    },

    setSpeed: function () {

      var self = this;

      window.clearTimeout( this.hasScrolled );
      
      this.hasScrolled = setTimeout(function() {
        //pJSDom[0].pJS.particles.move.speed = 2;

        self.hasScrolledOnce = true;
        self.postponeIdleTimer();
      }, 66);

      var scrollX = self.$refs.gallery.$el.scrollLeft;
      var elapsed = 50;
      var delta = scrollX - self.lastScrollX;
      self.lastScrollX = scrollX;
  
      var v = 1000 * delta / (1 + elapsed);
      self.speed = 0.8 * v + 0.2 * self.speed;

    },

    showDetail: function (id) {

      var image = _.find(this.imagesSrcListsRaw, {
        id: id
      });

      this.$refs.galleryDetail.setData(image);
    },

    scrollToYear: function (key) {

      var $pane = this.$el.querySelector(".tg-gallery__pane[data-key='" + key + "']");
      var offset = $pane.offsetLeft + $pane.offsetWidth - 0.8 * document.body.offsetWidth;
      var offset = this.$el.querySelector(".tg-gallery").scroll({
        top: 0, 
        left: offset,
        behavior: 'smooth' 
      });

    },

    imageLoaded: function (event) {
      event.path[0].classList.add('is--loaded');
    }

  }  
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  $mine-shaft-black: #232323;
  $tuatara-black: #323231;
  $pink: #fdc3c7;
  $burnt-sienna-orange: #ef6565;
  $accent-color: $burnt-sienna-orange;
  $grey: #e6e6e6;

  .tg-wrapper {
    background: url('../assets/timeline-bg.jpg');
    background-size: cover;
    background-position: center;
  }

  .home-overlay,
  .confetti-overlay {
    position: fixed;
    top: 0px;
    left: 0px;
    background: none;
    width: 100%;
    z-index: 99;
  }

  .home-overlay {
    box-sizing: border-box;
    height: calc(100vh);
    background: rgba(0,0,0,0.80);
    z-index: 99;
    font-size: 20px;
    padding: 4rem 10% 0 10%;
    line-height: 1.4;
  }
  
  .home-overlay--large {
    font-size: 24px;
    margin-bottom: 4rem;
  }

  .home-overlay--small {
    font-size: 16px;
  }

  .confetti-overlay {
    height: 100%;
    background: none;
    pointer-events: none;
    z-index: 99;
  }
  
  .meta-year {
    font-size: 30px;
    font-family: 'WalsheimBold';
  }

  .timeline-gallery {
    text-align: center;
  }

  .tg-gallery {
    display: flex;
    flex-direction: row;
    overflow-x: scroll;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    height: calc(100vh - 131px); 

    &::-webkit-scrollbar { 
      display: none;
      width: 0 !important; 
    }
  }

  .tg-gallery__pane {

    display: flex;
    flex-direction: row;
    padding: 0 75px;
    position: relative;
    justify-content: center;
    align-items: center;

    .meta-year {
      display: none;
      position: absolute;
      top: 50px;
      right: 75px;
      transition: opacity 0.2s, border-bottom-width 0.2s linear;
      border-bottom: 0px solid white;
    }

    &:not(.is--active) {
      .meta-year {
        opacity: 0.5;
      }
    }

    &.is--active {
      .meta-year {
        border-bottom-width: 2px;
      }
    }

    .image-frame {

      width: 25vw;
      position: relative;
      padding: 21px;
      position: relative;

      &:not(:last-child) {
        margin-right: 115px;
      }

      &.is--with-archive {
        &:after {
          display: block;
          content: '';
          height: 54px;
          width: 192px;
          background: url('../assets/archive-ribbon.png');
          position: absolute;
          bottom: 27px;
          left: -9px;
          z-index: 2;
        }
      }

      svg {
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%; 
        height: 100%;
        z-index: 0;
      }

      img.is--loaded + svg {
        display: block;
      }

      use {
        fill: white;
      }

      img {
        display: block;
        max-width: 100%;
        width: auto;
        margin: 0;
        position: relative;
        z-index: 1;
        border: 1px solid $grey;
      }

      .image-frame-header {
        position: absolute;
        top: -16px;
        left: 50%;
        transform: translate(-50%, -100%);
        width: 100%;
        text-align: center;

        .image-frame-header__title {
          font-size: 30px;
          font-family: 'WalsheimBold';
          color: $burnt-sienna-orange;
          text-transform: uppercase;
          text-decoration: underline;
          margin-bottom: 0;
        }

        .image-frame-header__subtitle {
          font-size: 15px;
          font-family: 'WalsheimRegular';
          color: white;
          text-align: center;

          &:before,
          &:after {
            border-top: 1px solid $burnt-sienna-orange;
            content: '';
            display: inline-block;
            height: 1px;
            position: relative;
            vertical-align: middle;
            width: 50px;
            margin-bottom: .15em;
          }
          &:before {
              right: 0.5em;
              margin-left: -50%;
          }
          &:after {
              left: 0.5em;
              margin-right: -50%;
          }
        }

      }

    } 
    
  }

  .tg-timeline {
    height: 131px;
    white-space: nowrap;
    position: relative;

    &:before,
    &:after {
      content: '';
      display: block;
      height: 95px;
      width: 40vw;
      position: absolute;
      top: 0;
      pointer-events: none;
    }

    /*&:before {
      left: 0;
      background: linear-gradient(to right, rgba(0,0,0,0.65) 0%,rgba(0,0,0,0) 100%);
    }

    &:after {
      right: 0;
      background: linear-gradient(to left, rgba(0,0,0,0.65) 0%,rgba(0,0,0,0) 100%);
    }*/

    .tg-timeline__scroller {
      height: 95px;
      margin: auto;
      overflow-x: scroll;
      display: flex;
      vertical-align: bottom;
      align-items: flex-end;
      margin-bottom: 0px;

      .meta-year {
        
        &:first-child {
          margin-left: 50vw!important;
        }

      }

      .scroll-offset {
        display: block;
        margin-left: calc(50vw - 70px)!important;
      }
      
      &::-webkit-scrollbar { 
        display: none;
        width: 0 !important; 
      }
    }

    .tg-timeline__sep {
      height: 1px;
      width: 100%;
      background-color: #EBE6D4; 
      margin-bottom: 21px;
    }

    .meta-year {
      transition: font-size 0.2s; 

      &:not(.is--active) {
        margin-bottom: 27px;
      }

      &.is--active {
        font-size: 70px;
        color: $accent-color;
        margin-bottom: 14px;
      }
    }
  }

</style>
